import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

export default function ConfirmPurchaseEmail() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const confirm = async () => {
    setError(null);
    const response = await fetch('/api/checkout/claim/confirm', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: params.get('token') || '' }),
    });
    const data = await response.json();
    if (!response.ok) {
      setError(t('checkout.claim_expired'));
      return;
    }
    setMessage(data.existingAccount ? t('checkout.email_moved') : t('checkout.email_confirmed'));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      <div className="container mx-auto px-6 py-16 max-w-lg text-white">
        <h1 className="text-3xl font-bold mb-4">{t('checkout.confirm_email_title')}</h1>
        {message ? <p className="text-green-300 mb-6">{message}</p> : (
          <button onClick={confirm} className="bg-gradient-to-r from-purple-600 to-pink-600 px-5 py-2 rounded-md">
            {t('checkout.confirm_email_button')}
          </button>
        )}
        {error && <p className="text-red-300 mt-4">{error}</p>}
        <Link to="/login" className="block mt-6 text-purple-300">{t('checkout.go_to_login')}</Link>
      </div>
    </div>
  );
}
